module.exports = __webpack_public_path__ + "media/veracruz/ConvocatoriaTorneoBasquetbol-8fea0c87.png";